module.exports = "/_next/static/images/DeliveryWarehousesETL-ace3435c3955fd6123497c2f4a17ad6f.webp";